var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconsGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.9987 10.666H8.66536V8.66602H3.9987V10.666ZM9.9987 10.666H11.9987V5.33268H9.9987V10.666ZM3.9987 7.33268H8.66536V5.33268H3.9987V7.33268ZM2.66536 13.3327C2.2987 13.3327 1.98481 13.2021 1.7237 12.941C1.46259 12.6799 1.33203 12.366 1.33203 11.9993V3.99935C1.33203 3.63268 1.46259 3.31879 1.7237 3.05768C1.98481 2.79657 2.2987 2.66602 2.66536 2.66602H13.332C13.6987 2.66602 14.0126 2.79657 14.2737 3.05768C14.5348 3.31879 14.6654 3.63268 14.6654 3.99935V11.9993C14.6654 12.366 14.5348 12.6799 14.2737 12.941C14.0126 13.2021 13.6987 13.3327 13.332 13.3327H2.66536ZM2.66536 11.9993H13.332V3.99935H2.66536V11.9993Z",
    fill: "#586C7F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGroup);
export default __webpack_public_path__ + "static/media/icons_group.b377290f.svg";
export { ForwardRef as ReactComponent };